<template>
  <div>

    <Loading v-if="!loaded" text="Cargando registros" class="w-100" />

    <template v-else>
      <div class="kpi-row">
        <div class="kpi-card kpi-card--total">
          <div class="kpi-card__main">
            <span class="kpi-card__icon"><i class="fas fa-paper-plane"></i></span>
            <div>
              <div class="kpi-card__label">Total envíos</div>
              <div class="kpi-card__value">{{ formatoNumero(kpis.total) }}</div>
            </div>
          </div>
          <span class="kpi-card__chart" aria-hidden="true"></span>
        </div>

        <div class="kpi-card kpi-card--ok">
          <div class="kpi-card__main">
            <span class="kpi-card__icon"><i class="fas fa-check"></i></span>
            <div>
              <div class="kpi-card__label">Exitosos</div>
              <div class="kpi-card__value">{{ formatoNumero(kpis.exitosos) }}</div>
              <div class="kpi-card__percent">{{ porcentaje(kpis.exitosos) }} del total</div>
            </div>
          </div>
          <span class="kpi-card__chart" aria-hidden="true"></span>
        </div>

        <div class="kpi-card kpi-card--error">
          <div class="kpi-card__main">
            <span class="kpi-card__icon"><i class="fas fa-times"></i></span>
            <div>
              <div class="kpi-card__label">Con error</div>
              <div class="kpi-card__value">{{ formatoNumero(kpis.errores) }}</div>
              <div class="kpi-card__percent">{{ porcentaje(kpis.errores) }} del total</div>
            </div>
          </div>
          <span class="kpi-card__chart" aria-hidden="true"></span>
        </div>

        <div class="kpi-card kpi-card--pending">
          <div class="kpi-card__main">
            <span class="kpi-card__icon"><i class="fas fa-clock"></i></span>
            <div>
              <div class="kpi-card__label">Pendientes</div>
              <div class="kpi-card__value">{{ formatoNumero(kpis.pendientes) }}</div>
              <div class="kpi-card__percent">{{ porcentaje(kpis.pendientes) }} del total</div>
            </div>
          </div>
          <span class="kpi-card__chart" aria-hidden="true"></span>
        </div>
      </div>

      <data-table
        v-if="registros.length"
        :headers="headers"
        :data="registros"
        :acciones="acciones"
        :seleccionar="verJson"
        :max="10"
        paginacion
        buscar
        idtabla="user_transitions"
      />

      <not-found-table
        v-else
        text="No se encontraron registros"
        class="justify-content-center w-100 pt-5"
      />
    </template>

    <ui-modal ref="modalJson" title="JSON" size="large">
      <pre class="json-modal" v-html="jsonSeleccionado"></pre>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-outline-secondary" @click="cerrarModal">
          Cerrar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataTable from "../../components/common/DataTable";
import NotFoundTable from "../../components/common/NotFoundTable";
import Loading from "../../components/common/loading.vue";
import { getUserTransitions } from "../../constants/superadministrador";

export default {
  components: {
    DataTable,
    NotFoundTable,
    Loading,
  },
  data() {
    return {
      headers: ["ID", "Usuario", "Cliente", "Tipo", "Fecha/Hora", "Estado de envío", "Respuesta API", "Mensaje", "Acciones"],
      registros: [],
      acciones: [],
      jsonSeleccionado: "",
      loaded: false,
      kpis: {
        total: 0,
        exitosos: 0,
        errores: 0,
        pendientes: 0,
      },
    };
  },
  methods: {
    ...mapActions(["AccionCambiar"]),
    async cargarRegistros() {
      this.loaded = false;
      try {
        const data = await getUserTransitions();
        const filas = data.data_table || [];
        const exitosos = filas.filter((row) => Number(row.data[5]) === 1).length;
        const errores = filas.filter((row) => Number(row.data[5]) === 0).length;
        this.kpis = {
          total: filas.length,
          exitosos,
          errores,
          pendientes: 0,
        };
        this.registros = filas.map((row) => {
          const fechaHora = String(row.data[4] || "");
          const [fecha, hora] = fechaHora.split(" ");
          const status = Number(row.data[5]);
          row.data[4] = { datetime: { date: fecha || "", time: hora || "" } };
          row.data[5] = status === 1
            ? { dot: "success", text: "Exitoso" }
            : { dot: "error", text: "Error" };
          return row;
        });
        this.acciones = this.registros.map((_, index) => [
          {
            icon: "fas fa-code",
            title: "Revisar detalle de json enviado",
            id: index,
          },
        ]);
      } catch (error) {
        this.registros = [];
        this.acciones = [];
        this.kpis = { total: 0, exitosos: 0, errores: 0, pendientes: 0 };
      }
      this.loaded = true;
    },
    verJson({ id, accion }) {
      if (accion !== "Revisar detalle de json enviado") return;

      const raw = this.registros[id]?.data_complementaria?.json ?? "";

      try {
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        this.jsonSeleccionado = this.formatearJson(parsed);
      } catch (error) {
        this.jsonSeleccionado = this.escapeHtml(raw);
      }

      this.$refs.modalJson.open();
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    formatearJson(value, indent = 0) {
      const pad = "  ".repeat(indent);
      const padIn = "  ".repeat(indent + 1);

      if (Array.isArray(value)) {
        if (!value.length) return "[]";
        const items = value.map((item) => padIn + this.formatearJson(item, indent + 1));
        return "[\n" + items.join(",\n") + "\n" + pad + "]";
      }

      if (value && typeof value === "object") {
        const keys = Object.keys(value);
        if (!keys.length) return "{}";
        const lines = keys.map((key) => {
          return (
            padIn +
            "<strong>" +
            this.escapeHtml(key) +
            "</strong>: " +
            this.formatearJson(value[key], indent + 1)
          );
        });
        return "{\n" + lines.join(",\n") + "\n" + pad + "}";
      }

      if (typeof value === "string") {
        const unaLinea = value.replace(/\s*\r?\n\s*/g, " ");
        return '"' + this.escapeHtml(unaLinea) + '"';
      }
      if (value === null) return "null";
      return String(value);
    },
    cerrarModal() {
      this.$refs.modalJson.close();
    },
    formatoNumero(valor) {
      return Number(valor || 0).toLocaleString("es-CL");
    },
    porcentaje(valor) {
      if (!this.kpis.total) return "0%";
      return ((Number(valor) / this.kpis.total) * 100).toFixed(1) + "%";
    },
  },
  created() {
    this.AccionCambiar(this.$route.path);
    this.cargarRegistros();
  },
};
</script>

<style scoped>
.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.kpi-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  padding: 18px 20px;
  min-height: 108px;
}

.kpi-card__main {
  display: flex;
  align-items: center;
  gap: 14px;
}

.kpi-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.kpi-card__label {
  font-size: 14px;
  color: #6b7280;
}

.kpi-card__value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  color: #1f2937;
}

.kpi-card__percent {
  font-size: 13px;
  font-weight: 600;
  margin-top: 2px;
}

.kpi-card__chart {
  width: 54px;
  height: 36px;
  background:
    linear-gradient(#93c5fd, #93c5fd) 0 18px / 8px 18px no-repeat,
    linear-gradient(#60a5fa, #60a5fa) 14px 8px / 8px 28px no-repeat,
    linear-gradient(#3b82f6, #3b82f6) 28px 14px / 8px 22px no-repeat,
    linear-gradient(#2563eb, #2563eb) 42px 4px / 8px 32px no-repeat;
  opacity: 0.85;
}

.kpi-card--total {
  background: #eef5ff;
}
.kpi-card--total .kpi-card__icon {
  background: #3b82f6;
}

.kpi-card--ok {
  background: #e9f8ef;
}
.kpi-card--ok .kpi-card__icon {
  background: #22a35a;
}
.kpi-card--ok .kpi-card__percent {
  color: #1f9d55;
}
.kpi-card--ok .kpi-card__chart {
  background:
    linear-gradient(#86efac, #86efac) 0 16px / 8px 20px no-repeat,
    linear-gradient(#4ade80, #4ade80) 14px 8px / 8px 28px no-repeat,
    linear-gradient(#22c55e, #22c55e) 28px 12px / 8px 24px no-repeat,
    linear-gradient(#16a34a, #16a34a) 42px 2px / 8px 34px no-repeat;
}

.kpi-card--error {
  background: #fdecec;
}
.kpi-card--error .kpi-card__icon {
  background: #ef4444;
}
.kpi-card--error .kpi-card__percent {
  color: #dc2626;
}
.kpi-card--error .kpi-card__chart {
  background:
    linear-gradient(#fca5a5, #fca5a5) 0 10px / 8px 26px no-repeat,
    linear-gradient(#f87171, #f87171) 14px 18px / 8px 18px no-repeat,
    linear-gradient(#ef4444, #ef4444) 28px 6px / 8px 30px no-repeat,
    linear-gradient(#dc2626, #dc2626) 42px 14px / 8px 22px no-repeat;
}

.kpi-card--pending {
  background: #fff8e8;
}
.kpi-card--pending .kpi-card__icon {
  background: #f5b942;
}
.kpi-card--pending .kpi-card__percent {
  color: #d97706;
}
.kpi-card--pending .kpi-card__chart {
  background:
    linear-gradient(#fcd34d, #fcd34d) 0 14px / 8px 22px no-repeat,
    linear-gradient(#fbbf24, #fbbf24) 14px 6px / 8px 30px no-repeat,
    linear-gradient(#f59e0b, #f59e0b) 28px 16px / 8px 20px no-repeat,
    linear-gradient(#d97706, #d97706) 42px 4px / 8px 32px no-repeat;
}

.json-modal {
  max-height: 60vh;
  overflow: auto;
  white-space: pre;
  word-break: normal;
  margin-bottom: 0;
}

::v-deep .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
  width: 70vw;
  max-width: 1100px;
}
</style>
